import React, { useState } from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Avatar, Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Logout as LogoutIcon, AccountCircle as AccountCircleIcon } from '@mui/icons-material';

const Navbar = () => {
  const navigate = useNavigate();
  const { isAuthenticated, logout, user, canAccessCCD, canAccessParish, canAccessStaff, canAccessMass, canAccessOCIA, canAccessCampusMinistry } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleMenuClose();
    try {
      await logout();
      navigate('/login');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          component={Link}
          to={isAuthenticated ? "/" : "/"}
          sx={{
            flexGrow: 1,
            textDecoration: 'none',
            color: 'inherit',
            '&:hover': {
              cursor: 'pointer'
            }
          }}
        >
          St. Bridget Staff Portal
        </Typography>
        <Box>
          {isAuthenticated ? (
            <>
              {canAccessCCD() && (
                <Button
                  color="inherit"
                  component={Link}
                  to="/religious-education"
                >
                  CCD Registrations
                </Button>
              )}
              {canAccessParish() && (
                <Button
                  color="inherit"
                  component={Link}
                  to="/parish-registration"
                >
                  Parish Registrations
                </Button>
              )}
              {canAccessStaff() && (
                <Button
                  color="inherit"
                  component={Link}
                  to="/staff"
                >
                  Staff
                </Button>
              )}
              {canAccessMass() && (
                <Button
                  color="inherit"
                  component={Link}
                  to="/mass"
                >
                  Mass
                </Button>
              )}
              {canAccessOCIA() && (
                <Button
                  color="inherit"
                  component={Link}
                  to="/ocia"
                >
                  OCIA
                </Button>
              )}
              {canAccessCampusMinistry() && (
                <Button
                  color="inherit"
                  component={Link}
                  to="/campus-ministry"
                >
                  Campus Ministry
                </Button>
              )}
              <IconButton onClick={handleMenuOpen} color="inherit">
                <Avatar 
                  alt={user ? user.name : 'User'} 
                  src={user ? user.profilePictureUrl : ''} 
                  sx={{ width: 32, height: 32 }}
                >
                  {!user?.profilePictureUrl && <AccountCircleIcon />}
                </Avatar>
              </IconButton>
              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleMenuClose}
                keepMounted
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
              >
                {user && (
                  <MenuItem disabled sx={{ pointerEvents: 'none' }}>
                    <ListItemText primary={user.name} secondary={user.email} />
                  </MenuItem>
                )}
                <MenuItem onClick={handleLogout}>
                  <ListItemIcon>
                    <LogoutIcon fontSize="small" />
                  </ListItemIcon>
                  <ListItemText>Logout</ListItemText>
                </MenuItem>
              </Menu>
            </>
          ) : null}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar; 